/**
 * @generated SignedSource<<d8f2841c8c9403272d9d46d0598dd326>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightInfoEndpoint_segment$data = {
  readonly arrivalAirportCode: string;
  readonly arrivalDatetime: string;
  readonly departAirportCode: string;
  readonly departDatetime: string;
  readonly " $fragmentType": "FlightInfoEndpoint_segment";
};
export type FlightInfoEndpoint_segment$key = {
  readonly " $data"?: FlightInfoEndpoint_segment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightInfoEndpoint_segment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightInfoEndpoint_segment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departAirportCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalAirportCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalDatetime",
      "storageKey": null
    }
  ],
  "type": "FlightSegment",
  "abstractKey": null
};

(node as any).hash = "aa33da82b0311f201269ab793a40559d";

export default node;
